<script setup>
import { ref, onMounted } from "vue";
import cookies from "browser-cookies";
import { policyUrl } from "@/utils/provider";
import { initYandexMetrika } from "@/utils/metrika";

const COOKIE_NAME = "cookieConsent";
const COOKIE_EXPIRATION_DAYS = 182;

const show = ref(false);

onMounted(() => {
	const consent = cookies.get(COOKIE_NAME);
	if (!consent) {
		show.value = true;
	} else {
		// initYandexMetrika();
	}
});

const acceptCookies = () => {
	cookies.set(COOKIE_NAME, "true", { expires: COOKIE_EXPIRATION_DAYS });
	show.value = false;
	// initYandexMetrika();
};
</script>
<template>
	<div class="cookies" v-if="show">
		<div class="cookies__container">
			<div class="cookies__content">
				<p>
					Мы используем файлы cookie для улучшения вашего опыта на сайте. Продолжая использовать наш сайт, вы соглашаетесь с использованием файлов cookie. Подробнее о нашей
					<a target="_blank" :href="policyUrl">политике конфиденциальности.</a>
				</p>
			</div>
			<button class="btn cookies__btn --small --blue" @click="acceptCookies">Согласиться</button>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.cookies {
	position: fixed;
	width: 67%;
	left: 50%;
	bottom: 12px;
	transform: translateX(-50%);
	background: #fff;
	border-radius: 2.4rem;
	padding: 1.6rem 1.4rem 1.6rem 3.2rem;
	border: 1px solid rgba(14, 14, 14, 0.24);
	z-index: 3;
	@media (max-width: vars.$m) {
		padding: 1.6rem;
	}
	@media (max-width: vars.$x480) {
		padding: 1.2rem 1rem;
		border-radius: 1.4rem;
		width: 95%;		
	}
}
.cookies__container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 2.4rem;
	@media (max-width: vars.$xx) {
		flex-direction: column;
		gap: 1.2rem;
	}
}
.cookies__content {
	max-width: 97.7rem;
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 140%;	
	@media (max-width: vars.$x480) {
		font-size: 1.2rem;
	}
	a {
		white-space: nowrap;
		color: #0e0e0e;
		border-bottom: 1px solid currentColor;
		@media (hover: hover) {
			&:hover {
				border-color: transparent;
			}
		}
	}
}

.cookies__btn {
	padding: 2.3rem 3rem;
	@media (max-width: vars.$xx) {
		width: 100%;
	}
	@media (max-width: vars.$x480) {
		padding: 1.4rem 2.2rem;
	}
	@media (hover: hover) {
		&:hover {
		}
	}
}
</style>
